import { TIMESCALE, FUEL_TYPE, USAGE_TYPE, USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW, TEMPERATURE, ONGOING, NA, SHC_BC, USAGE_COLORS, TIME_OF_USE, INSIGHT_USAGE_V2_VIEWS, INSIGHT_USAGE_CHART_DISCLAIMERS, USER_TYPE, TIER } from '../constants/common';
import { createDummyDataHomeItemizationXAxis } from '../helpers/noDataHelper';
import { Configuration } from '../configs/Configuration';
import { displayUsage, displayCost, formatDate, displayPower } from './helper';

export const checkIfArrayOfZeroes = (arr) => {
    if (arr && arr.length > 0) {
        return arr.every(item => item === 0 || item === null)
    }
    return true;
}

export const fetchBillingCycleDateBoundaries = (params) => {
    let start = 0;
    let end = Math.floor(new Date().getTime()/1000);
    let dateFormat = 'DATE_TIME';
    if (params.mode === TIMESCALE.MONTH) {
        start = params.dataMonthStart ? params.dataMonthStart : start;
        end = params.dataMonthEnd ? params.dataMonthEnd : end;
    }
    if (params.mode === TIMESCALE.DAY) {
        start = params.dataDayStart ? params.dataDayStart : start;
        end = params.dataDayEnd ? params.dataDayEnd : end;
    }
    if (params.mode === SHC_BC) {
        dateFormat = 'MONTH_IN_WORDS_SPACE_DAY_COMMA_YEAR';
    }

    return {
        start: start,
        end: end,
        dateFormat: dateFormat
    };
}

export const getDataNotAvailableText = (params, translations) => {
    let dataNotAvailableText = '';
    if (params.mode === TIMESCALE.YEAR) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.YEAR"];
    }else if (params.mode === TIMESCALE.MONTH) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.MONTH"];
    }else if (params.mode === TIMESCALE.DAY) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.DAY"];
    }else if (params.mode === SHC_BC) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.SHC"];
    }
    return dataNotAvailableText;
}

export const createVariableFromApplianceName = (key, type) => {
    return ("data" + key + type.charAt(0).toUpperCase() + type.substring(1));
}

export const setUsageChartDataForYear = (graphApiData, appliancesList) => {
    let data = {
        dataNACost: [], dataNAEnergy: [], dataTimeStampsYear: [],
        dataOngoingCost: [], dataOngoingEnergy: [], dataYearCost: [], dataYearEnergy: [],
        touData : {
            dataOffPeakEnergy: [], dataOffPeakCost: [],
            dataMidPeakEnergy: [], dataMidPeakCost: [], dataPeakEnergy: [],
            dataPeakCost: []
        },
        tierData : {
            dataTier0Cost: [], dataTier1Cost: [], dataTier2Cost: [],
            dataTier0Energy: [], dataTier1Energy: [], dataTier2Energy: [],
        }
    };
    let keys = Object.keys(appliancesList);
    keys.forEach(key => {
        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)] = [];
        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)] = [];
        return key;
    });

    graphApiData.map( (item, index) => {
        //Push billingcycle start and end to create array of billingCycles
        data.dataTimeStampsYear.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });

        data.dataYearCost.push(item.cost ? item.cost : 0);
        data.dataYearEnergy.push(item.consumption ? item.consumption : 0);

        if (item.itemizationDetailsList) {
            let itemizationDetailsList = item.itemizationDetailsList;
            //Create array of itemizations from api to feed highcharts
            itemizationDetailsList.map(item => {
                keys.forEach(key => {
                    if (item.id == key) {
                        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(item.cost ? item.cost : 0);
                        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(item.usage ? item.usage : 0);
                        return key;
                    }
                });
                return item;
            });

            //If itemization for a specific category is not present for that billing cycle, pad with 0
            keys.forEach(key => {
                if (data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].length !== index + 1) {
                    data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                    data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                }
                return key;
            });

            data.dataNACost.push(0);
            data.dataNAEnergy.push(0);
        }else {
            //If itemization is not present, push into itemization unavailable or ongoing cycle array and pad other arrays with 0 value
            if (item.isOngoingInterval) {
                //If it is the ongoing billing cycle, push into that array. Create an array of that lenth and then push the next value
                data.dataOngoingCost = new Array(index).fill(0);
                data.dataOngoingEnergy = new Array(index).fill(0);
                data.dataOngoingCost.push(item.cost ? item.cost : 0);
                data.dataOngoingEnergy.push(item.consumption ? item.consumption : 0);
                data.dataNACost.push(0);
                data.dataNAEnergy.push(0);
            }else {
                //If ongoing is false, push into itemization not available array
                //If cost/consumption is null, then push 0
                data.dataNACost.push(item.cost ? item.cost : 0);
                data.dataNAEnergy.push(item.consumption ? item.consumption : 0);
            }
            keys.forEach(key => {
                data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                return key;
            });
        }
        let isTouInterval = item.touDetails && item.touDetails.touRrcMap;
        //Prepare and push TOU data if present
        if(isTouInterval){
            populateTouData(item, data.touData);
        }
        //Prepare and push TIER data if present
        if(item.tierDetails && item.tierDetails.tierRrcMap){
            populateTierData(item, data.tierData, isTouInterval);
        }
    });
    return data;
}

export const setUsageChartDataForMonth = (graphApiData) => {
    let dataTimeStampsMonth = [], dataMonthCost = [], dataMonthEnergy = [], isWeekend = [];
    let touData = {
        dataOffPeakEnergy: [], dataOffPeakCost: [],
        dataMidPeakEnergy: [], dataMidPeakCost: [], dataPeakEnergy: [],
        dataPeakCost: []
    }
    let tierData = {
        dataTier0Cost: [], dataTier1Cost: [], dataTier2Cost: [],
        dataTier0Energy: [], dataTier1Energy: [], dataTier2Energy: [],
    }
    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        dataTimeStampsMonth.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });
        dataMonthCost.push(item.cost);
        dataMonthEnergy.push(item.consumption);
        isWeekend.push(item.isWeekend);
        //Prepare and push TOU data if present
        populateTouData(item, touData);
        let isTouInterval = item.touDetails && item.touDetails.touRrcMap;
        populateTierData(item, tierData, isTouInterval);
    });
    let insightsDataLeftArrowDisabled = graphApiData[0].isBoundaryInterval;
    let insightsDataRightArrowDisabled = graphApiData[graphApiData.length - 1].isBoundaryInterval;

    return {
        dataTimeStampsMonth,
        dataMonthCost,
        dataMonthEnergy,
        isWeekend,
        touData,
        tierData,
        insightsDataLeftArrowDisabled,
        insightsDataRightArrowDisabled
    };
}


export const setSHChartDataForBC = (graphApiData, mode, selectedAppliance) => {
    let bcTimeStampsData = [];
    let youSeriesData = [];
    let efficientSeriesData = [];
    let averageSeriesData = [];

    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        bcTimeStampsData.push({
            start: item.intervalStart,
            end: item.intervalEnd,
            isMissingDataInterval: item.isMissingDataInterval
        });

        let applianceInfo = item.applianceInfo[selectedAppliance];
        let youVal = null;
        let averageVal = null;
        let efficientVal = null;
        let isCost = mode == USAGE_TYPE.COST;

        //If data is null, convert them to zero
        if (!item.isMissingDataInterval && applianceInfo) {
            youVal = isCost ? applianceInfo.userCost : applianceInfo.userCons;
            averageVal = isCost ? applianceInfo.averageSHCCost : applianceInfo.averageSHCCons;
            efficientVal = isCost ? applianceInfo.efficientSHCCost : applianceInfo.efficientSHCCons;
        }
        youSeriesData.push(youVal);
        averageSeriesData.push(averageVal);
        efficientSeriesData.push(efficientVal);
    });

    return {
        bcTimeStampsData,
        youSeriesData,
        averageSeriesData,
        efficientSeriesData
    };
}

export const setUsageChartDataForDay = (graphApiData) => {
    let dataTimeStampsDay = [];

    let dataDayCost = [], dataDayEnergy = [];
    let touData = {
        dataOffPeakEnergy: [], dataOffPeakCost: [],
        dataMidPeakEnergy: [], dataMidPeakCost: [], dataPeakEnergy: [],
        dataPeakCost: []
    }
    let tierData = {
        dataTier0Cost: [], dataTier1Cost: [], dataTier2Cost: [],
        dataTier0Energy: [], dataTier1Energy: [], dataTier2Energy: [],
    }
    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        dataTimeStampsDay.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });
        dataDayCost.push(item.cost);
        dataDayEnergy.push(item.consumption);
        //Prepare and push TOU data if present
        populateTouData(item, touData);
        let isTouInterval = item.touDetails && item.touDetails.touRrcMap;
        populateTierData(item, tierData, isTouInterval);
    });

    let insightsDataLeftArrowDisabled = graphApiData[0].isBoundaryInterval;
    let insightsDataRightArrowDisabled = graphApiData[graphApiData.length - 1].isBoundaryInterval;

    return {
        dataTimeStampsDay,
        dataDayCost,
        dataDayEnergy,
        touData,
        tierData,
        insightsDataLeftArrowDisabled,
        insightsDataRightArrowDisabled
    };
}

export const populateTouData = (item, data) => {
    let offPeakAvailable = item.touDetails && item.touDetails.touRrcMap["Off-Peak"];
    let midPeakDataAvailable = item.touDetails && item.touDetails.touRrcMap["Mid-Peak"];
    let onPeakDataAvailable = item.touDetails && item.touDetails.touRrcMap["On-Peak"];

    data.dataOffPeakCost.push( offPeakAvailable && item.touDetails.touRrcMap["Off-Peak"].tierCost ? item.touDetails.touRrcMap["Off-Peak"].tierCost : 0);
    data.dataOffPeakEnergy.push( offPeakAvailable && item.touDetails.touRrcMap["Off-Peak"].tierConsKwh ? item.touDetails.touRrcMap["Off-Peak"].tierConsKwh : 0);
    data.dataMidPeakCost.push( midPeakDataAvailable && item.touDetails.touRrcMap["Mid-Peak"].tierCost ? item.touDetails.touRrcMap["Mid-Peak"].tierCost : 0);
    data.dataMidPeakEnergy.push( midPeakDataAvailable && item.touDetails.touRrcMap["Mid-Peak"].tierConsKwh ? item.touDetails.touRrcMap["Mid-Peak"].tierConsKwh : 0);
    data.dataPeakCost.push( onPeakDataAvailable && item.touDetails.touRrcMap["On-Peak"].tierCost ? item.touDetails.touRrcMap["On-Peak"].tierCost : 0);
    data.dataPeakEnergy.push( onPeakDataAvailable && item.touDetails.touRrcMap["On-Peak"].tierConsKwh ? item.touDetails.touRrcMap["On-Peak"].tierConsKwh : 0);
}


export const populateTierData = (item, data, isTouInterval) => {
    let tiers = Object.keys(TIER);
    for (let i = 0; i< tiers.length; i++) {
        let tierKey = tiers[i];
        let tierAvailable = item.tierDetails && item.tierDetails.tierRrcMap[tierKey] && !isTouInterval;
        data[`dataTier${tierKey}Cost`].push(tierAvailable && item.tierDetails.tierRrcMap[tierKey].tierCost || 0);
        data[`dataTier${tierKey}Energy`].push(tierAvailable && item.tierDetails.tierRrcMap[tierKey].tierConsKwh || 0);
    }
}

export const setTooltip = (currentObj, self) => {
    let total = 0, checkIfNA = false, checkIfOngoing = false;

    let switchCostEnergy = self.props.insightsBillUsageData.switchCostEnergy;
    let switchGasElectric = self.props.insightsBillUsageData.switchGasElectric;

    //Fetch index of point to calculate the index of billing cycle duration from array of dataBillingCycleDuration
    let index = currentObj.points[0].point.index;
    if (self.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
        //If length is greater than 13, then show calculated index or else take default index by default
        index = self.props.insightsBillUsageData.dateStrings.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? self.props.insightsBillUsageData.dateStrings.length - (USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - index + self.props.insightsBillUsageData.datasYearIndexOffset) : index;
    }

    //Show tooltip based on mode
    let dateString = self.props.insightsBillUsageData.dateStrings[index];

    let tooltipData = formatDate(dateString.startDate, self.props.configs.data[`DATE_FORMATS.${self.props.insightsBillUsageData.mode.toUpperCase()}.TOOLTIP`]);

    if (self.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
        tooltipData += (" - " + formatDate(dateString.endDate, self.props.configs.data["DATE_FORMATS.YEAR.TOOLTIP"]));
    }

    //Calculate total excluding temperature values
    currentObj.points.map(item => item.series.name !== TEMPERATURE.NAME ? total += item.y : total);
    total = formatCostOrElectricValues(self.props.insightsBillUsageData.switchCostEnergy, self.props.insightsBillUsageData.switchGasElectric, total);

    let returnObj = currentObj.points.reduce(function(s, point) {
        if (self.props.insightsBillUsageData.mode !== TIMESCALE.YEAR) {
            if (point.series.name === TEMPERATURE.NAME && self.props.insightsBillUsageData.showWeather) {
                return s +
                    "<span class='insights-highcharts-tooltip-item-container'> " +
                        "<span class='insights-highcharts-tooltip-item-text insights-highcharts-tooltip-item-text-center'><b>" + self.props.translations.data["USAGE.TEMPERATURE"] + ": " + point.y + ' ' + self.props.configs.data["weather_unit"] + "</b></span>" +
                    "</span>";
            }else {
                return s;
            }
        }else if (point.series.name === NA.NAME) {
            if (point.y > 0) {
                checkIfNA = true;
            }
            return s;
        }else if (point.series.name === ONGOING.NAME && point.y > 0 ) {
            checkIfOngoing = true;
            return s;
        }else if (point.series.name === TEMPERATURE.NAME && self.props.insightsBillUsageData.showWeather) {
            return s +
                "<span class='insights-highcharts-tooltip-item-container'> " +
                    "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-temperature'></span>" +
                    "<span style='background-color: " + point.color + "'; class='insights-highcharts-tooltip-temperature-strikethrough'></span>" +
                    "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + self.props.configs.data["weather_unit"] + "</b>" + self.props.translations.data["USAGE.TEMPERATURE"] + "</span>" +
                "</span>";
        }else if (!checkIfNA && !checkIfOngoing && point.y !== 0) {
            return s +
                "<span class='insights-highcharts-tooltip-item-container'> " +
                    "<span style='background-color: " + point.color + "' class='insights-highcharts-tooltip-color'></span>" +
                    "<span class='insights-highcharts-tooltip-item-text'><b>" + formatCostOrElectricValues(switchCostEnergy, switchGasElectric, point.y) + "</b>" + point.series.name + "</span>" +
                "</span>";
        }else {
            return s;
        }
    }, '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
        '<span class="insights-highcharts-tooltip-total">' + self.props.translations.data["USAGE.TOTAL"] + ': ' + total + '</span></b>')

    if (checkIfNA) {
        return '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
            '<span class="insights-highcharts-tooltip-total">' + self.props.translations.data["USAGE.TOTAL"] + ': ' + total + '</span>' +
            '<b class="insights-highcharts-tooltip-unavailable">' + self.props.translations.data["USAGE.DISCLAIMER.ITEMIZATION_UNAVAILABLE"] + '</b>';
    }else if (checkIfOngoing) {
        return '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
            '<span class="insights-highcharts-tooltip-total">' + self.props.translations.data["INSIGHTS.USAGE.CURRENT_CONSUMPTION"] + ': ' + total + '</span>' +
            '<b class="insights-highcharts-tooltip-unavailable">' + self.props.translations.data["USAGE.DISCLAIMER.ONGOING_BILLING_CYCLE"] + '</b>';
    }else {
        return returnObj;
    }
}

export const setTooltipV2 = (currentObj, data, mode, view, configs, translations, isDemandChargeChart) => {
    let intervalDetails = null;
    let tooltipHTML = '';
    let index = null;
    if(data && currentObj.points && currentObj.points.length && currentObj.points[0].point){
        index = currentObj.points[0].point.index
        intervalDetails = data[index];
    }
    if(intervalDetails){
        let dateFormat = configs[`DATE_FORMATS.${mode.toUpperCase()}.TOOLTIP`];
        let isOngoingInterval = intervalDetails.isOngoingInterval;
        let isItemizationAvailable = intervalDetails.itemizationDetailsList;
        let usageType = view === INSIGHT_USAGE_V2_VIEWS.USAGE ? USAGE_TYPE.ENERGY : USAGE_TYPE.COST;
        let total = usageType === USAGE_TYPE.COST ? intervalDetails.cost : intervalDetails.consumption;
        total = total ? total : 0;
        total = formatCostOrElectricValues(usageType, FUEL_TYPE.ELECTRIC, total);
        let range = formatDate(intervalDetails.intervalStartDate, dateFormat);
        if(mode === TIMESCALE.YEAR){
            range += (" - " + formatDate(intervalDetails.intervalEndDate, dateFormat))
        }
        //Set Range
        tooltipHTML += '<span class="insights-highcharts-tooltip-title">' + range + '</span>';
        switch(view){
            case INSIGHT_USAGE_V2_VIEWS.APPLIANCE:{
                if(!isOngoingInterval && isItemizationAvailable){
                    //Set Total value
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total v2">' + translations["USAGE.TOTAL"] + ': ' + total + '</span>';
                    //Set individual point values
                    currentObj.points.map(point =>{
                        if(point.y > 0 && point.series.name !== TEMPERATURE.NAME && point.percentage < 100){
                            tooltipHTML +=
                            "<span class='insights-highcharts-tooltip-item-container'> " +
                                "<span style='background-color: " + point.color + "' class='insights-highcharts-tooltip-color'></span>" +
                                "<span class='insights-highcharts-tooltip-item-text'><b>" + formatCostOrElectricValues(usageType, FUEL_TYPE.ELECTRIC, point.y) + "</b>" + point.series.name + "</span>" +
                            "</span>";
                        } else if( point.series.name === TEMPERATURE.NAME){
                            tooltipHTML +=
                            "<span class='insights-highcharts-tooltip-item-container'> " +
                                "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-temperature'></span>" +
                                "<span style='background-color: " + point.color + "'; class='insights-highcharts-tooltip-temperature-strikethrough'></span>" +
                                "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + configs["weather_unit"] + "</b>" + point.series.name + "</span>" +
                            "</span>";
                        }
                    })
                } else if(isOngoingInterval){
                    //Set Cuurent usage value and add disclaimer
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total">' + translations["INSIGHTS.USAGE.CURRENT_CONSUMPTION"] + ': ' + total + '</span>' +
                    '<b class="insights-highcharts-tooltip-unavailable">' + translations["USAGE.DISCLAIMER.ONGOING_BILLING_CYCLE"] + '</b>';
                } else if(!isItemizationAvailable){
                    //Set Total value and add disclaimer
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total v2">' + translations["USAGE.TOTAL"] + ': ' + total + '</span>' +
                    '<b class="insights-highcharts-tooltip-unavailable">' + translations["USAGE.DISCLAIMER.ITEMIZATION_UNAVAILABLE"] + '</b>';
                }
            }
            break;
            case INSIGHT_USAGE_V2_VIEWS.COST:{
                if(!isOngoingInterval){
                    //Set Total value
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total v2">' + translations["USAGE.TOTAL"] + ': ' + total + '</span>';
                } else if(isOngoingInterval){
                    //Set Cuurent usage value
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total">' + translations["INSIGHTS.USAGE.CURRENT_CONSUMPTION"] + ': ' + total + '</span>';
                }
                //Set individual point values
                currentObj.points.map(point =>{
                    let rateText = '';
                    let pointName = point.series.name;
                    if(point.series.userOptions && point.series.userOptions.name){
                        let tierName = point.series.userOptions.name;
                        Object.keys(TIER).map(tier => {
                            if(tierName.includes(translations[`INSIGHTS.USAGE.TIER.${tier}.NAME`])){
                                pointName = translations[`INSIGHTS.USAGE.TIER.${tier}.NAME`];
                                rateText = translations[`INSIGHTS.USAGE.TIER.${tier}.RATE`];
                            }
                        });
                        Object.keys(TIME_OF_USE).map(tou => {
                            let touName = point.series.userOptions.name;
                            if(touName.includes(translations[`DASHBOARD.USAGE.TOU.${TIME_OF_USE[tou].type}`])){
                                rateText = translations[`INSIGHTS.USAGE.TOU.${TIME_OF_USE[tou].type}.RATE`];
                            }
                        });
                    }
                    if(point.y > 0 && point.series.name !== TEMPERATURE.NAME && point.percentage < 100){
                        tooltipHTML +=
                        "<span class='insights-highcharts-tooltip-item-container'> " +
                            "<span style='background-color: " + point.color + "' class='insights-highcharts-tooltip-color'></span>" +
                            "<span class='insights-highcharts-tooltip-item-text'><b>" + formatCostOrElectricValues(usageType, FUEL_TYPE.ELECTRIC, point.y) + "</b>" + pointName + (rateText ? ' (' + rateText + ')' : '') +"</span>" +
                        "</span>";
                    }
                });
                currentObj.points.map(point => {
                    if( point.series.name === TEMPERATURE.NAME){
                        tooltipHTML +=
                        "<span class='insights-highcharts-tooltip-item-container'> " +
                            "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-temperature'></span>" +
                            "<span style='background-color: " + point.color + "'; class='insights-highcharts-tooltip-temperature-strikethrough'></span>" +
                            "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + configs["weather_unit"] + "</b>" + point.series.name + "</span>" +
                        "</span>";
                    }
                })
            }
            break;
            case INSIGHT_USAGE_V2_VIEWS.USAGE:{
                if(!isOngoingInterval && !isDemandChargeChart){
                //Set Total value
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total v2">' + translations["USAGE.TOTAL"] + ': ' + total + '</span>';
                } else if(isOngoingInterval && !isDemandChargeChart){
                    //Set Cuurent usage value
                    tooltipHTML += '<span class="insights-highcharts-tooltip-total">' + translations["INSIGHTS.USAGE.CURRENT_CONSUMPTION"] + ': ' + total + '</span>';
                }
                currentObj.points.map(point =>{
                    if( point.series.name === TEMPERATURE.NAME){
                        tooltipHTML +=
                        "<span class='insights-highcharts-tooltip-item-container'> " +
                            "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-temperature'></span>" +
                            "<span style='background-color: " + point.color + "'; class='insights-highcharts-tooltip-temperature-strikethrough'></span>" +
                            "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + configs["weather_unit"] + "</b>" + point.series.name + "</span>" +
                        "</span>";
                    }
                    if(point.series.name === translations['INSIGHTS.USAGE.PEAK_DEMAND']){
                        tooltipHTML+=
                        "<span class='insights-highcharts-tooltip-item-container'> " +
                            "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-demand'></span>"  +
                            "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + "</b>" + point.series.name + "</span>" +
                        "</span>";
                    }
                });
            }
            break;
            default:
            break;
        }
    }
    return tooltipHTML;
}

export const prepareUsageHistoryChartData = (chartApiData, displayValue) => {
    let xData = [], yData =[];
    let chartData = chartApiData;
    if (chartApiData.length === 0) {
        xData = createDummyDataHomeItemizationXAxis();
        for (let i = 0; i < 13; i++ ) {
            yData.push(Math.round(Math.random() * 400));
        }
    }else {
        if(chartApiData.length > 12){
            chartData = chartData.slice(chartApiData.length -12);
        }
        chartData.map ( item => {
            xData.push(item.intervalEndDate);
            let val = (displayValue === USAGE_TYPE.COST) ? item.cost : item.consumption;
            yData.push(val || 0);
        })
    }
    return {
        xAxisData : xData,
        yAxisData : yData
    }
}

export const checkIfDataEmpty = (array) => {
    for (let i = 0; i < array.length; i++) {
        if (!checkIfArrayOfZeroes(array[i].data)) {
            return false;
        }
    }
    return true;
}

export const formatCostOrElectricValues = (costOrEnergy, gasOrElectric, value) => {
    return costOrEnergy === USAGE_TYPE.COST ? displayCost({cost: value, showCurrency: true}) : displayUsage({usage: value, showUsageUnit: true,  fuelType: gasOrElectric});
}


export const getHighchartOptions = () => {
    let configColors = Configuration.getColors().colors;
    let options = {
        legend: {
            itemStyle: {
                color: `rgb(${configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`,
                fontWeight: 'normal',
            },
            itemHoverStyle : {
                cursor : 'default'
            }
        },
        tooltip: {
            useHTML: true,
            outside: true,
            backgroundColor: `rgb(${configColors[USAGE_COLORS.TOOLTIP_BACKGROUND_COLOR_V2]})`,
            shared: true,
            borderColor: `rgb(${configColors[USAGE_COLORS.TOOLTIP_BACKGROUND_COLOR_V2]})`,
            borderWidth: 1
        },
        plotOptions: {
            series: {
                maxPointWidth: 50,
                animation: false,
            },
            column: {
                stacking: 'normal',
                events: {
                    legendItemClick: function () {
                        return false
                    }
                }
            },
            area: {
                stacking: 'normal',
                marker: {
                    enabled: false,
                    symbol: "circle"
                },
                events: {
                    legendItemClick: function () {
                        return false
                    }
                }
            },
        }
    }
    return options;
}

export const getXAxisData = (apiResponse, mode, view, format, translations, isDemandChargeChart) =>{
    let configColors = Configuration.getColors().colors;

    let categories = [];
    if(apiResponse && apiResponse.length){
        apiResponse.map( item => {
            //Push dates in axis and billing cycle duration after modifying to feed highcharts
            categories.push(formatDate(mode === TIMESCALE.YEAR ? item.intervalEndDate : item.intervalStartDate, format));
        });
    }

    let dataXAxis = [{
        crosshair : true,
        categories : categories,
        labels: {
            formatter: function() {
                let disclaimerIcon = !isDemandChargeChart ? getDisclaimerIcon(apiResponse[this.pos], mode, view, translations) : '';
                let color = mode === TIMESCALE.MONTH && apiResponse[this.pos].isWeekend ? USAGE_COLORS.ITEMIZATION_WEEKEND_COLOR : USAGE_COLORS.ITEMIZATION_LEGEND_COLOR;
                return `<span style="color: rgb(${configColors[color]})">${this.value}${disclaimerIcon}</span>`;
            }
        }
    }]
    return dataXAxis;
}

export const getDisclaimerIcon = (data, mode, view, translations) => {
    let iconNum = 0;
    if(data){
        if(data.isOngoingInterval && view === INSIGHT_USAGE_V2_VIEWS.APPLIANCE){
            iconNum = 1;
        } else if(mode === TIMESCALE.YEAR && view === INSIGHT_USAGE_V2_VIEWS.APPLIANCE && !data.itemizationDetailsList){
            iconNum = 2;
        } else if(data.isMissingDataInterval){
            iconNum = 3;
        }
    }
    return translations[`DISCLAIMER_ICONS.USAGE.ICON${iconNum}`] || '';
}

export const getYAxisData = (view, fuelType, weatherUnit, isDemandChargeChart)=>{
    let configColors = Configuration.getColors().colors;
    return [{ // Primary yAxis
        title: {
            text: '',
        },
        labels: {
            formatter: function(){
                return !isDemandChargeChart ? (view === USAGE_TYPE.USAGE ? displayUsage({usage: this.value, showUsageUnit: true , fuelType}) : (displayCost({cost: this.value , showCurrency: true, round: false}))) : displayPower({value: this.value, showPowerUnit : true, round: false});
            },
            style: {
                color: `rgb(${configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`
            }
        }
    }, { // Secondary yAxis
        title: {
            text: '',
        },
        labels: {
            format: '{value}' + ' ' + weatherUnit,
            style: {
                color: `rgb(${configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`
            }
        },
        opposite: true
    }];
}

export const getTimeOfUseChartData = (timeOfUse, data, view) =>{
    if(data){
        switch(timeOfUse){
            case TIME_OF_USE.OFF_PEAK.type : {
                return view === INSIGHT_USAGE_V2_VIEWS.COST ?  data.dataOffPeakCost : data.dataOffPeakEnergy;
            }
            case TIME_OF_USE.MID_PEAK.type : {
                return view === INSIGHT_USAGE_V2_VIEWS.COST ? data.dataMidPeakCost : data.dataMidPeakEnergy;
            }
            case TIME_OF_USE.ON_PEAK.type : {
                return view === INSIGHT_USAGE_V2_VIEWS.COST ? data.dataPeakCost : data.dataPeakEnergy;
            }
        }
    }

}

export const getRemainingCategoriesData = (view, selectedCategory, data, applianceDefaultMode) => {
    switch(view){
        case INSIGHT_USAGE_V2_VIEWS.APPLIANCE : {
            let selectedDataVariable = createVariableFromApplianceName(selectedCategory, applianceDefaultMode);
            let selectedData = data[selectedDataVariable];
            let dataYear = applianceDefaultMode === USAGE_TYPE.COST ? data.dataYearCost : data.dataYearEnergy;
            for(let i=0; i<dataYear.length; i++){
                dataYear[i] -= selectedData[i];
            }
            return [...dataYear];
        }
        break;
        case INSIGHT_USAGE_V2_VIEWS.COST : {
            let selectedData = data.touData["data" + TIME_OF_USE[selectedCategory].itemizationKey +  "Cost"];
            let dataYearCost = data.dataYearCost;
            for(let i=0; i<dataYearCost.length; i++){
                dataYearCost[i] -= selectedData[i];
            }
            return [...dataYearCost];
        }
        break;
        default:
        break;
    }
}

export const prepareDataFromApiResponse = (apiResponse, mode, appliancesList) => {
    let data = null;
    switch(mode){
        case TIMESCALE.YEAR : {
            data = setUsageChartDataForYear(apiResponse, appliancesList);
        }
        break;
        case TIMESCALE.MONTH : {
            data = setUsageChartDataForMonth(apiResponse);
        }
        break;
        case TIMESCALE.DAY : {
            data = setUsageChartDataForDay(apiResponse);
        }
        break;
        default:
        break;
    }
    return data;
}

export const getTemperatureData = (apiResponse) => {
    let temperatureData = [];
    if(apiResponse){
        apiResponse.map(item => {
            temperatureData.push(item.temperature);
        });
    }
    return [...temperatureData];
}

export const getDemandChargeData = (apiResponse) => {
    let demandChargeData =  [];
    if(apiResponse){
        apiResponse.map(item => {
            demandChargeData.push(item.peakDemand ? item.peakDemand.value : null);
        });
    }
    return [...demandChargeData];
}

// Check if a given mode is supported for a given view. Currently - APPLIANCE view does not support MONTH mode.
export const isModeSupported = (mode, view) => {
    return view === INSIGHT_USAGE_V2_VIEWS.APPLIANCE && mode !== TIMESCALE.YEAR ? false : true;
}

export const getDisclaimers = (data, mode, view, yearOffset) =>{
    let apiResponse = data;
    let disclaimers = [];
    if(mode == TIMESCALE.YEAR && apiResponse){
        apiResponse = cropYearData(data, yearOffset);
    }
    if(apiResponse && apiResponse.length){
        apiResponse.map(item => {
            if(view === INSIGHT_USAGE_V2_VIEWS.APPLIANCE && item.isOngoingInterval){
                addToArrayIfNotPresent(disclaimers, INSIGHT_USAGE_CHART_DISCLAIMERS.ONGOING_BILLING_CYCLE.name)
            }
            else if(view === INSIGHT_USAGE_V2_VIEWS.APPLIANCE && !item.itemizationDetailsList){
                addToArrayIfNotPresent(disclaimers, INSIGHT_USAGE_CHART_DISCLAIMERS.ITEMIZATION_UNAVAILABLE.name);
            }
            else if(item.isMissingDataInterval){
                addToArrayIfNotPresent(disclaimers, INSIGHT_USAGE_CHART_DISCLAIMERS.MISSING_DATA.name);
            }
            else if(item.userType === USER_TYPE.NSM){
                disclaimers.push(INSIGHT_USAGE_CHART_DISCLAIMERS.NSM_CYCLE.name);
            }
        });
    }
    return disclaimers;
}


export const addToArrayIfNotPresent = (data, value) =>{
    if(data && data.indexOf(value) == -1){
        data.push(value);
    }
}

// Show maximum of 13 (USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW) months data in year view.
export const cropYearData = (apiResponse, offset) => {
    let itemsToShow = USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW;
    if(apiResponse && apiResponse.length && apiResponse.length > itemsToShow){
        let startIndex = apiResponse.length + offset - itemsToShow;
        let endIndex = startIndex + itemsToShow;
        let  newResp = apiResponse.slice(startIndex, endIndex);
        return newResp;
    } else if(apiResponse && apiResponse.length){
        return apiResponse;
    }
}

export const isTouDataPresent = (apiResponse, offset, mode) => {
    let data = mode === TIMESCALE.YEAR ? cropYearData(apiResponse, offset) : apiResponse;
    if(data && data.length){
        for(let i=0; i<data.length; i++){
            if(data[i].touDetails && data[i].touDetails.touRrcMap){
                return true;
            }
        }
    }
    return false;
}

export const checkAllArraysZero = (obj) => {
    let allArraysZero = true;
    if(obj && Object.keys(obj).length){
        Object.keys(obj).map(item => {
            if(!checkIfArrayOfZeroes(obj[item])){
                allArraysZero = false;
            }
        })
    }
    return allArraysZero;
}

export const getChartDisclaimer = (translations, mode, view, isFixedRatePlan, isTou) => {
    let translationKey = 'INSIGHTS.USAGE.CHART_DISCLAIMER.';
    switch(view){
        case INSIGHT_USAGE_V2_VIEWS.APPLIANCE:{
            translationKey += 'APPLIANCE';
        }
        break;
        case INSIGHT_USAGE_V2_VIEWS.COST:{
            if(isFixedRatePlan){
                translationKey += 'FIXED.' + mode;
            } else if(isTou){
                translationKey += 'TOU.' + mode;
            } else {
                translationKey += 'TIER.' + mode;
            }
        }
        break;
        case INSIGHT_USAGE_V2_VIEWS.USAGE:{
            translationKey += 'USAGE.' + mode;
        }
        break;
        default:
        break;
    }
    return translations[translationKey];
}

export const getIntervalDetails = (apiResponse, mode, yearOffset, configs) => {
    let dateFormat = configs[`DATE_FORMATS.${mode.toUpperCase()}.BILLING_CYCLE_DURATION`];
    if(apiResponse && apiResponse.length){
        let data = apiResponse;
        if(mode === TIMESCALE.DAY){
            return formatDate(data[0].intervalStartDate, dateFormat);
        }
        if(mode === TIMESCALE.YEAR){
            data = cropYearData(apiResponse, yearOffset);
        }
        return formatDate(data[0].intervalStartDate, dateFormat) + ' - ' + formatDate(data[data.length - 1].intervalEndDate, dateFormat);
    }
}
export const isDemandChargePresent = (apiResponse, offset, view, mode) =>{
    if(apiResponse && view === INSIGHT_USAGE_V2_VIEWS.USAGE){
        let data = mode === TIMESCALE.YEAR ? cropYearData(apiResponse, offset) : apiResponse;
        data.map(intervalDetails => {
            if(intervalDetails.peakDemand && intervalDetails.peakDemand.value){
                return true;
            }
        })
    }
    return false;
}

export const showBillProjection = (billProjectionData, apiResponse, view, mode) => {
    let showBP = false;
    if(apiResponse && view === INSIGHT_USAGE_V2_VIEWS.COST && mode === TIMESCALE.MONTH.toUpperCase() && billProjectionData && billProjectionData.data){
        apiResponse.map(item => {
            if(item.isOngoingInterval){
                showBP = true;
            }
        });
    }
    return showBP;
}